<template>
  <OurConfirmModal
    v-model="isShownModal"
    :title="$t('promotions.endEarly')"
    :action-button-text="$t('promotions.endEarly')"
    color="red"
    @actionConfirmed="onConfirm"
  >
    <OurTextBlock>
      <span v-html="$t('promotions.endEarlyConfirm', { name })" />
    </OurTextBlock>
  </OurConfirmModal>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";
import { endDealerIncentiveEarlyMutation } from "@/views/settings/promotions/edit/gql/mutations";

export default {
  name: "EndEarlyConfirmModal",

  mixins: [apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    promotionId: {
      type: String,
      default: "",
    },

    name: {
      type: String,
      default: "",
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    async onConfirm() {
      const { endDealerIncentiveEarly } = await this.$post(
        endDealerIncentiveEarlyMutation,
        { id: this.promotionId },
        { delaySuccessNotify: true }
      );

      if (endDealerIncentiveEarly?.id) {
        this.$emit("endedEarly", endDealerIncentiveEarly);
      }
    },
  },
};
</script>
